"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideToolbarControls = void 0;
const UiElements_1 = require("../../ui/UiElements");
class SideToolbarControls {
    constructor(parentEl) {
        if (!parentEl) {
            throw new Error('Parent element (SideToolbar) is undefined');
        }
        this.menuBtn = this.createButton('menuToggler', 'menu', '3D_MODEL_INSPECTOR');
        this.annotationsBtn = this.createButton('annotationsToggler', 'annotation-open', 'ANNOTATIONS');
        this.hdBtn = this.createButton('highDefinition', 'sd', 'HD');
        this.fullscreenBtn = this.createButton('fullScreen', 'full-screen', 'FULLSCREEN', 'right-bound');
        this.annotationsBtn.setClass('active');
        if (!document.fullscreenEnabled) {
            parentEl.append(this.menuBtn.domEl, this.annotationsBtn.domEl, this.hdBtn.domEl);
            return;
        }
        parentEl.append(this.menuBtn.domEl, this.annotationsBtn.domEl, this.hdBtn.domEl, this.fullscreenBtn.domEl);
    }
    removeAnnotationsBtn() {
        this.annotationsBtn.domEl.remove();
    }
    dispose() {
        var _a;
        (_a = this.fullscreenBtn) === null || _a === void 0 ? void 0 : _a.domEl.remove();
    }
    createButton(id, iconName, tooltip, classes) {
        return new UiElements_1.ButtonEl()
            .setId(id)
            .setClass(classes || '')
            .addAttribute('data-i18n-attr', `data-title=${tooltip}`)
            .addChild(new UiElements_1.IconEl(iconName));
    }
}
exports.SideToolbarControls = SideToolbarControls;
